<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <p>
          Duty of Care Waste Transfer Note
        </p>
        <v-simple-table>
          <tr>
            <td style="vertical-align: top">Current Waste Holder</td>
            <td>
              {{ drs.quotation.customer.name }}<br />
              {{ drs.quotation.customer.address_1 }}<br />
              {{ drs.quotation.customer.address_2 }}<br />
              {{ drs.quotation.customer.address_3 }}<br />
              {{ drs.quotation.customer.address_4 }}<br />
              {{ drs.quotation.customer.address_5 }}<br />
              {{ drs.quotation.customer.postcode }}
            </td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
            <td style="vertical-align: top">Waste Producer & Carrier</td>
            <td>
              Riggott & Co. Ltd<br />
              Unit X Lodge Lane Industrial Estate<br />
              Tuxford<br />
              Newark<br />
              NG22 0NL
            </td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
            <td>Registered Waste Carrier No.</td>
            <td>CBDU221242</td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
            <td>SIC Code</td>
            <td>43999</td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
            <td>
              Description of Waste
            </td>
            <td>
              {{ drs.waste_type }}
            </td>
          </tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr>
            <td>
              No of bags
            </td>
            <td>
              {{ drs.waste_quantity }}
            </td>
          </tr>
        </v-simple-table>
        <p class="no-print pt-4">
            <v-btn @click="print()">Print</v-btn>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'PrintWasteTransferNotes',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      drs: {
        site_location: '',
        waste_notes: '',
        waste_quantity: 0,
        waste_type: '',
        waste_transfer: false,
      },
    };
  },
  methods: {
    print() {
      window.print();
    },
    getDrs() {
      const drsId = this.$route.params.id;
      axios.get(`/dailyReturnSheets/getView/${drsId}.json?token=${this.token}`)
        .then((response) => {
          this.drs = response.data.dailyReturnSheet;
        });
    },
  },
  mounted() {
    this.getDrs();
  },
};
</script>
